import { render, staticRenderFns } from "./NewContentDomainModal.vue?vue&type=template&id=1d779145&lang=pug&"
import script from "./NewContentDomainModal.vue?vue&type=script&lang=js&"
export * from "./NewContentDomainModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports